const isSuperUser = (user) => {
  if (!user?.role) return false
  if (user.role.name === 'iboxen-admin') return true
  return false
}

const IBOXEN_CARRIER_ID = '605b5119c1a82f357597bfc8'

const isIboxenCarrier = (carrier) =>
  carrier?._id?.toString() === IBOXEN_CARRIER_ID

const userIsAllowedTo = (user, action) => {
  if (!user?.role) return false
  if (isSuperUser(user)) return true
  return user.role.allowedTo.includes(action)
}

const carrierIsIboxen = (carrier) => carrier?.isIboxen === true

const carrierIsAllowedTo = (carrier, action) => {
  if (!carrier) return false
  if (carrierIsIboxen(carrier)) return true
  return (carrier.allowedTo || []).includes(action)
}

/**
 * Whether this user is looking at the portal as a carrier that is not their own.
 *
 * Picking another carrier in the header sends every request as them and the server answers with
 * their carrier, so being scoped to a carrier that is not iBoxen is what acting as one means — a
 * super user's own carrier is iBoxen.
 *
 * It takes a carrier we actually know: an empty or half-loaded one is not somebody else, and
 * treating it as such would hide things for as long as /me was in flight.
 */
const seeingAsAnotherCarrier = (user, carrier) =>
  isSuperUser(user) && Boolean(carrier?._id) && !carrierIsIboxen(carrier)

export {
  isSuperUser,
  isIboxenCarrier,
  IBOXEN_CARRIER_ID,
  userIsAllowedTo,
  carrierIsAllowedTo,
  carrierIsIboxen,
  seeingAsAnotherCarrier,
}
